import React from 'react';
import { Stack } from '@mui/material';
import { withStyles } from '@material-ui/core';
import VTypography from '../../Venti-UI-Kit/VTypography/VTypography';
import styles from './styles';

const AutocompleteOption = ({ option, onClick, classes }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1.5}
      onClick={onClick}
      className={classes.optionContainer}
    >
      <Stack className={classes.optionAvatar}>
        {option.logoImg ? (
          <img src={option.logoImg} alt={option.name} className={classes.optionAvatarImage} />
        ) : (
          <VTypography variant="body2" fontWeight={600}>
            {option.name?.charAt(0)?.toUpperCase()}
          </VTypography>
        )}
      </Stack>
      <Stack>
        <VTypography variant="body1" fontWeight={500}>
          {option.name}
        </VTypography>
        {option.visibility === 'hidden' && (
          <VTypography variant="body2" fontWeight={500} color="#f57c00">
            Productora no visible
          </VTypography>
        )}
      </Stack>
    </Stack>
  );
};

export default withStyles(styles)(AutocompleteOption);
